import {
  Button,
  column,
  GridColumn,
  GridDataRow,
  GridTableLayout,
  PageHeaderLayout,
  RowStyles,
  simpleDataRows,
  SimpleHeaderAndData,
  useGridTableLayoutState,
  useModal,
  UseModalHook,
} from "@homebound/beam";
import { useMemo } from "react";
import {
  TradeCategoryInfoFragment,
  useGetTradeCategoriesQuery,
} from "src/routes/trade-categories/TradeCategories.generated";
import { TradeCategoriesEditor } from "./TradeCategoriesEditor";

export function TradeCategories() {
  const { data } = useGetTradeCategoriesQuery();
  const modal = useModal();
  const layoutState = useGridTableLayoutState({ search: "client" });
  const columns = useMemo(createColumns, []);
  const rows: GridDataRow<Row>[] = useMemo(() => simpleDataRows(data?.tradeCategories || []), [data]);

  return (
    <PageHeaderLayout
      pageHeader={{
        title: "Trade Categories",
        rightSlot: (
          <Button
            label="Add new Trade Category"
            onClick={() => {
              modal.openModal({ size: "sm", content: <TradeCategoriesEditor /> });
            }}
          />
        ),
      }}
    >
      <GridTableLayout
        hideEditColumns
        layoutState={layoutState}
        tableProps={{ columns, rows, rowStyles: createRowStyles(modal), sorting: { on: "client" } }}
      />
    </PageHeaderLayout>
  );
}

type Row = SimpleHeaderAndData<TradeCategoryInfoFragment>;

function createColumns(): GridColumn<Row>[] {
  return [
    column<Row>({ header: "Code", data: (d) => d.number, w: "100px" }),
    column<Row>({ header: "Name", data: (d) => d.name }),
  ];
}

function createRowStyles(modal: UseModalHook): RowStyles<Row> {
  return {
    header: {},
    data: {
      onClick: (row) => {
        modal.openModal({ size: "sm", content: <TradeCategoriesEditor tradeCategory={row.data} /> });
      },
    },
  };
}
